<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="9">
        <h3>Form</h3>
        <el-form ref="form" :model="form" :key="key" label-width="150px" style="margin-top: 20px">
          <el-form-item label="Date" required>
            <el-date-picker
              v-model="form.datee"
              type="month"
              placeholder="Pick a month" />
          </el-form-item>
          <el-form-item label="Number Of Days" required>
            <el-input v-model="form.numberOfDays" placeholder="Please input" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveData">Create</el-button>
            <el-button @click="refresh">Refresh</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :md="15">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Number of days of Casual personnel</span>
            <div style="float: right;">
              <el-date-picker
                v-model="term"
                type="year"
                placeholder="Pick a year"
                @change="getAll"/>
            </div>
            <!--el-button style="float: right; padding: 3px 0" type="text">Operation button</el--->
          </div>
          <el-alert
            :closable="false"
            title="Reminder"
            type="warning"
            description="Dont forget to compute ACA and PERA after adding number of days"
            show-icon />
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="year"
              label="Year"/>
            <el-table-column
              prop="month"
              label="Month">
              <template slot-scope="scope">
                {{ months[(scope.row.month * 1) - 1] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="numberOfDays"
              label="Number Of Days"/>
            <el-table-column label="Operation" align="center" width="250px">
              <template slot-scope="scope">
                <el-button type="warning" size="small" @click="edit(scope.row)"><i class="fas fa-edit"/></el-button>
                <el-button v-if="0 === scope.$index && ableCalc" type="primary" size="small" @click="computeACAPERA(scope.row)">Compute ACA and PERA</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="5" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CasualDays } from '../../../api/payroll/casualDays'
import { NotifyError, NotifySuccess } from '../../../helper/Helper'

export default {
  name: 'CasualDays',
  data() {
    return {
      form: {
        'did': null,
        'datee': new Date(),
        'numberOfDays': null
      },
      loading: false,
      tableData: [],
      personnel: {},
      term: this.getFormattedYear(new Date()),
      key: 0,
      meta: {
        page: 1
      },
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      year: this.getFormattedYear(new Date()),
      ableCalc: true
    }
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.ableCalc = parseInt(this.getFormattedYear(this.term)) === parseInt(this.year)
      this.loading = true
      this.refresh()
      CasualDays({ term: this.getFormattedYear(this.term) }, 'get', 'getCasualDaysList').then(res => {
        // console.log(res.data)
        this.tableData = res.data.CDNumberDays
        this.loading = false
      }).catch()
    },
    refresh() {
      this.form = {
        'did': null,
        'datee': new Date(),
        'numberOfDays': null
      }
    },
    saveData() {
      this.loading = true
      this.form.datee = this.getFormattedDate(this.form.datee)
      CasualDays(this.form, 'post', 'saveCasualDays').then(res => {
        if (res.data.success === false) {
          NotifyError(res.data.message)
        } else {
          NotifySuccess(res.data.message)
        }
        this.getAll()
      }).catch()
    },
    getFormattedDate(date) {
      return this.$moment(date).format('YYYY-MM-DD')
    },
    getFormattedYear(date) {
      return this.$moment(date).format('YYYY')
    },
    edit(row) {
      this.key++
      this.form.did = row.id
      this.form.datee = this.getFormattedDate(row.year + '-' + row.month + '-01')
      this.form.numberOfDays = row.numberOfDays
    },
    computeACAPERA(row) {
      this.loading = true
      CasualDays({ numberOfDays: row.numberOfDays }, 'post', 'computeACAPERA').then(res => {
        if (res.data.success === false) {
          NotifyError(res.data.message)
        } else {
          NotifySuccess(res.data.message)
        }
        this.getAll()
      }).catch()
    }
  }
}
</script>

<style scoped>

</style>
